
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3kPYw", function(module, exports) {
/**
 * @generated SignedSource<<d4837320ad3d1e70acd89afe763d8875>>
 * @relayHash 26162da9421b897123835870aa889a88
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a3004a6a0ad1b804118c2ddd213ca62e54dddd52039fedc3d0b3477084c941b9
const $1d0c8a8dbf14d1c8$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "requestPageAccessInput"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "requestPageAccessInput",
                    "variableName": "requestPageAccessInput"
                }
            ],
            "concreteType": "RequestPageAccessPayload",
            "kind": "LinkedField",
            "name": "requestPageAccess",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "displayName"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageRequestPageAccessMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageRequestPageAccessMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "26162da9421b897123835870aa889a88",
            "id": "a3004a6a0ad1b804118c2ddd213ca62e54dddd52039fedc3d0b3477084c941b9",
            "metadata": {},
            "name": "RestrictedPageRequestPageAccessMutation",
            "operationKind": "mutation",
            "text": "mutation RestrictedPageRequestPageAccessMutation($requestPageAccessInput:RequestPageAccessInput!){requestPageAccess(requestPageAccessInput:$requestPageAccessInput){displayName}}"
        }
    };
}();
$1d0c8a8dbf14d1c8$var$node.hash = "bfa35553df246be210070fea4313ce8c";
var $1d0c8a8dbf14d1c8$export$2e2bcd8739ae039 = $1d0c8a8dbf14d1c8$var$node;



var $e5EnV = parcelRequire("e5EnV");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $aXWIB = parcelRequire("aXWIB");


var $T1bCI = parcelRequire("T1bCI");


var $inPa6 = parcelRequire("inPa6");


var $ccHMk = parcelRequire("ccHMk");

var $7p4As = parcelRequire("7p4As");


var $fT2ta = parcelRequire("fT2ta");


var $6f0Oj = parcelRequire("6f0Oj");

var $dcJ7R = parcelRequire("dcJ7R");

var $5dK2X = parcelRequire("5dK2X");

var $ecnYn = parcelRequire("ecnYn");


var $kevJM = parcelRequire("kevJM");


var $6eGYE = parcelRequire("6eGYE");


var $bQm3c = parcelRequire("bQm3c");


var $d9tcB = parcelRequire("d9tcB");


var $cTt7H = parcelRequire("cTt7H");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $1uFM6 = parcelRequire("1uFM6");


var $4PPzL = parcelRequire("4PPzL");


var $7LI3Q = parcelRequire("7LI3Q");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $gqqjz = parcelRequire("gqqjz");


var $8dwdz = parcelRequire("8dwdz");


var $1NBp8 = parcelRequire("1NBp8");


var $jlIaF = parcelRequire("jlIaF");


var $auKqk = parcelRequire("auKqk");


var $ep3mz = parcelRequire("ep3mz");


var $7Sm4c = parcelRequire("7Sm4c");


var $3GP6F = parcelRequire("3GP6F");


var $cLo2u = parcelRequire("cLo2u");


var $dPJCf = parcelRequire("dPJCf");


var $dmDX7 = parcelRequire("dmDX7");


var $e4o8D = parcelRequire("e4o8D");


var $1UCmC = parcelRequire("1UCmC");


var $6mKj3 = parcelRequire("6mKj3");


var $jMyy4 = parcelRequire("jMyy4");


var $308Wd = parcelRequire("308Wd");


var $f3euL = parcelRequire("f3euL");

var $9f1b88c13fff6236$exports = {};
$9f1b88c13fff6236$exports = new URL("CantViewLight.81544b8c.svg", import.meta.url).toString();


var $ff8291cb754a7148$exports = {};
$ff8291cb754a7148$exports = new URL("CantViewDark.ef25ef94.svg", import.meta.url).toString();


var $1ed32d3dfa80d2bc$exports = {};
$1ed32d3dfa80d2bc$exports = new URL("CantEditLight.0ee7f232.svg", import.meta.url).toString();


var $3683726cdffbc364$exports = {};
$3683726cdffbc364$exports = new URL("CantEditDark.190a22b1.svg", import.meta.url).toString();



var $c9iq1 = parcelRequire("c9iq1");


var $fxpoI = parcelRequire("fxpoI");


var $9at9H = parcelRequire("9at9H");

const $cc1cd145e3df0c55$var$RestrictedPageWithCanViewQueryGraphQL = (0, $e5EnV.default);
const $cc1cd145e3df0c55$var$RestrictedPageRequestPageAccessMutationGraphQL = (0, $1d0c8a8dbf14d1c8$export$2e2bcd8739ae039);
const $cc1cd145e3df0c55$var$SUCCESS_FLAG_ID = 'reqestAccessSuccess';
const $cc1cd145e3df0c55$var$ButtonContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMobile: isMobile, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _19pk1ejb _1e0c1txw",
            __cmplp.isMobile ? "_1bah1h6o" : "_1bah1e5h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc1cd145e3df0c55$var$buttonPlaceholderStyles = (0, $ecnYn.xcss)({
    marginLeft: 'space.100',
    height: '32px',
    width: '32px',
    display: 'flex',
    alignItems: 'center'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc1cd145e3df0c55$var$RequestConfirmationTextContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_4cvr1h6o _1bah1h6o _1e0c1txw _4t3izwfg _19bvu2gc _u5f3u2gc",
            __cmplp.className
        ])
    });
});
const $cc1cd145e3df0c55$var$CUSTOM_ATTRIBUTES = {
    inaccessiblePageType: 'RESTRICTED_PAGE'
};
const $cc1cd145e3df0c55$var$i18n = (0, $aXWIB.defineMessages)({
    requestSentTitle: {
        id: "no-permission.restricted.page.request.access.successful.title.2",
        defaultMessage: "Request sent"
    },
    requestFailedTitle: {
        id: "no-permission.restricted.page.request.access.failed.title",
        defaultMessage: "Access request unsuccessful"
    },
    requestFailedBody: {
        id: "no-permission.restricted.page.request.access.failed.message.2",
        defaultMessage: "We ran into a problem submitting your access request. Try again or contact your admin."
    }
});
const $cc1cd145e3df0c55$var$LICENSED_ACCESS_STATUSES = new Set([
    (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS,
    (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS,
    (0, $d9tcB.AccessStatus).EXTERNAL_COLLABORATOR_ACCESS
]);
const $cc1cd145e3df0c55$var$RestrictedPageComponent = ({ accessType: accessType, contentId: contentId, editDeniedButCanView: editDeniedButCanView, flags: flags, viewLink: viewLink, showSuperAdminGateway: showSuperAdminGateway = true })=>{
    const { formatMessage: formatMessage } = (0, $aXWIB.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const [contentType] = (0, $ep3mz.useContentType)();
    const [requestSent, setRequestSent] = (0, $42omo.useState)(false);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { pendingRequestExists: pendingRequestExists, isLoadingForFirstTime: isLoadingForFirstTime, error: pendingAccessRequestExistsError } = (0, $dmDX7.usePendingRequestExists)({
        contentId: contentId
    });
    const { from: from } = (0, $3GP6F.useFeatureCodesInURL)();
    (0, $42omo.useEffect)(()=>{
        // Yes, it's always a 'page' viewed, even if contentType is something
        // else. It's just how this screen is registered.
        createAnalyticsEvent({
            type: 'sendScreenEvent',
            data: {
                name: 'restrictedPageViewed',
                action: 'viewed',
                actionSubject: 'page',
                actionSubjectId: 'restrictedPage',
                attributes: {
                    accessType: accessType || 'unspecified',
                    contentId: contentId,
                    contentType: contentType,
                    editDeniedButCanView: editDeniedButCanView,
                    from: from
                }
            }
        }).fire();
    }, [
        accessType,
        contentId,
        contentType,
        editDeniedButCanView,
        viewLink,
        createAnalyticsEvent,
        from
    ]);
    const makeLinkClickedHandler = (buttonLocation)=>()=>{
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'viewPageButton',
                    source: 'restrictedPageScreen',
                    attributes: {
                        buttonLocation: buttonLocation,
                        accessType: accessType || 'unspecified',
                        contentId: contentId,
                        contentType: contentType
                    }
                }
            }).fire(); // If the link was in a flag, hide the flag, since this might be an
            // SPA transition.
            flags.hideFlag($cc1cd145e3df0c55$var$SUCCESS_FLAG_ID);
        }; /** Displays the success or failure flags after access is requested */ 
    const handleRequestComplete = (result)=>{
        const requestSuccessful = result?.requestPageAccess?.displayName;
        if (requestSuccessful) flags.showSuccessFlag({
            isAutoDismiss: true,
            id: $cc1cd145e3df0c55$var$SUCCESS_FLAG_ID,
            title: formatMessage($cc1cd145e3df0c55$var$i18n.requestSentTitle),
            actions: editDeniedButCanView ? [
                {
                    content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                        id: "no-permission.restricted.page.flag.view-content",
                        defaultMessage: "View the content now"
                    }),
                    onClick: makeLinkClickedHandler('access-requested-flag'),
                    href: viewLink
                }
            ] : undefined
        });
        else flags.showErrorFlag({
            isAutoDismiss: true,
            title: formatMessage($cc1cd145e3df0c55$var$i18n.requestFailedTitle),
            description: formatMessage($cc1cd145e3df0c55$var$i18n.requestFailedBody)
        });
        setRequestSent(true);
    };
    const handleRequestError = ()=>{
        flags.showErrorFlag({
            isAutoDismiss: true,
            title: formatMessage($cc1cd145e3df0c55$var$i18n.requestFailedTitle),
            description: formatMessage($cc1cd145e3df0c55$var$i18n.requestFailedBody)
        });
        setRequestSent(true);
    };
    const [requestAccess] = (0, $308Wd.useMutationInterop)($cc1cd145e3df0c55$var$RestrictedPageRequestPageAccessMutationGraphQL, {
        variables: {
            requestPageAccessInput: {
                pageId: contentId ?? '',
                accessType: accessType === 'edit' ? 'EDIT' : 'VIEW'
            }
        },
        onCompleted: handleRequestComplete,
        onError: handleRequestError,
        __callerPackage__: "@confluence/no-permission"
    });
    const renderTitle = ()=>accessType === 'edit' ? editDeniedButCanView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.edit-but-can-view.title",
            defaultMessage: "You don\u2019t have access to edit this content"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.edit.title",
            defaultMessage: "Editing is restricted for this content"
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.view.title",
            defaultMessage: "You\u2019ve stumbled on restricted content"
        });
    const renderMessage = ()=>accessType === 'inherited' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.inherited.message",
            defaultMessage: "This is because it\u2019s inheriting restrictions from a parent item. A space admin or the person who shared this content may be able to give you access."
        }) : renderAccessRequest();
    const handleRequestAccessClick = async ()=>{
        try {
            setRequestAccessButtonLoading(true);
            setAnimateTextDirection(true);
            createAnalyticsEvent({
                type: 'sendUIEvent',
                data: {
                    action: 'clicked',
                    actionSubject: 'button',
                    actionSubjectId: 'requestAccessButton',
                    source: 'restrictedPageScreen',
                    attributes: {
                        accessType: accessType || 'unspecified',
                        contentId: contentId,
                        contentType: contentType,
                        editDeniedButCanView: editDeniedButCanView
                    }
                }
            }).fire();
            await requestAccess(); // eslint-disable-next-line @typescript-eslint/no-unused-vars
        } catch (e) {}
        setRequestAccessButtonLoading(false);
    };
    const [animateTextDirection, setAnimateTextDirection] = (0, $42omo.useState)(false);
    const [requestAccessButtonLoading, setRequestAccessButtonLoading] = (0, $42omo.useState)(false);
    const restrictionsImageLightMode = accessType === 'edit' ? (0, (/*@__PURE__*/$parcel$interopDefault($1ed32d3dfa80d2bc$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($9f1b88c13fff6236$exports)));
    const restrictionsImageDarkMode = accessType === 'edit' ? (0, (/*@__PURE__*/$parcel$interopDefault($3683726cdffbc364$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($ff8291cb754a7148$exports)));
    const renderRequestSentConfirmation = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            entranceDirection: animateTextDirection ? 'right' : undefined,
            distance: "proportional",
            key: "confirmation-text-animation"
        }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc1cd145e3df0c55$var$RequestConfirmationTextContainer, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $dcJ7R.default), {
                alignBlock: "center",
                space: "space.050",
                grow: "hug"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kevJM))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)",
                size: "small"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5dK2X.default), {
                color: "color.text.subtlest",
                weight: "medium"
            }, accessType === 'edit' && !pendingRequestExists ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "no-permission.restricted.page.request.edit-access.request-sent-confirmation",
                defaultMessage: "Edit requested"
            }) : // This serves double purpose for confirming VIEW requests or
            // Confirming there's an existing request of unknown accessType
            // This happens when the page loads and we call the API to know if there's a request.
            // Currently it doesn't tell us what request type it is, so we make it sound generic
            // Until the API gets updated, which should be easy
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "no-permission.restricted.page.request.view-access.request-sent-confirmation",
                defaultMessage: "Access requested"
            })))));
    const renderRequestAccessButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fT2ta.default), {
            duration: "large",
            key: "primary-button-animation"
        }, ({ ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ccHMk.default), {
                onClick: handleRequestAccessClick,
                appearance: "primary",
                isLoading: requestAccessButtonLoading
            }, accessType === 'edit' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "no-permission.restricted.page.request.edit-access",
                defaultMessage: "Ask to edit"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
                id: "no-permission.restricted.page.request.view-access",
                defaultMessage: "Ask for access"
            }))));
    const { accessStatus: accessStatus } = (0, $bQm3c.useSessionData)();
    const isLicensed = !!accessStatus && $cc1cd145e3df0c55$var$LICENSED_ACCESS_STATUSES.has(accessStatus);
    const renderButtonOrExistingRequestText = ()=>{
        if (isLoadingForFirstTime || pendingAccessRequestExistsError || renderServerPlaceholder || !isLicensed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $6f0Oj.default), {
            xcss: $cc1cd145e3df0c55$var$buttonPlaceholderStyles
        });
        if (pendingRequestExists || requestSent) return renderRequestSentConfirmation();
        return renderRequestAccessButton();
    }; /** Renders the access request call to action and message */ 
    const renderAccessRequest = ()=>contentId ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, accessType === 'edit' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.edit.request.access.from.author",
            defaultMessage: "Only some people can edit this content. If you want to edit it, you can ask the owner."
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.view.request.access.from.author",
            defaultMessage: "Only some people can view this content. If you want access, you can ask the owner."
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc1cd145e3df0c55$var$ButtonContainer, {
            isMobile: (0, $8dwdz.shouldShowMobileWeb)()
        }, editDeniedButCanView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7p4As.default), {
            href: viewLink,
            onClick: makeLinkClickedHandler('main')
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.view-content",
            defaultMessage: "View content"
        })), renderButtonOrExistingRequestText())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $aXWIB.FormattedMessage), {
            id: "no-permission.restricted.page.manual.request.access.from.author",
            defaultMessage: "Only some people can view this. If you think you should have access, try asking the person who sent you here for help."
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $auKqk.ErrorPageComponent), {
        errorImage: restrictionsImageLightMode,
        errorImageDark: restrictionsImageDarkMode,
        errorTitle: renderTitle(),
        errorMessage: renderMessage()
    }, showSuperAdminGateway && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $c9iq1.SuperAdminGateway), {
        type: "page",
        contentId: contentId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $cTt7H.PageLoadEnd), {
        metric: (0, $f3euL.INACCESSIBLE_PAGE_LOAD),
        customData: {
            ...$cc1cd145e3df0c55$var$CUSTOM_ATTRIBUTES,
            contentId: contentId
        }
    }));
};
const $cc1cd145e3df0c55$var$RestrictedPageWithCanViewQuery = (props)=>{
    const { accessType: accessType, contentId: contentId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const skipViewQuery = accessType !== 'edit';
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const { replace: replace } = (0, $dPJCf.useRouteActions)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($cc1cd145e3df0c55$var$RestrictedPageWithCanViewQueryGraphQL, {
        variables: {
            id: contentId ?? ''
        },
        skip: skipViewQuery,
        fetchPolicy: 'network-only',
        __callerPackage__: "@confluence/no-permission"
    });
    const editDeniedButCanView = skipViewQuery ? false : Boolean(data?.singleContent) && data?.singleContent?.status !== 'draft';
    const viewLink = editDeniedButCanView ? `${0, $jlIaF.CONTEXT_PATH}${data?.singleContent?.links?.webui}` : null;
    const canBeSuperAdmin = Boolean(data?.user?.confluence?.roles?.canBeSuperAdmin); // Only redirect user if:
    // 1. They have a viewLink available.
    // 2. They can't be super admin.
    const shouldRedirectToView = spaceKey && viewLink && !canBeSuperAdmin;
    (0, $42omo.useEffect)(()=>{
        if (shouldRedirectToView) {
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'redirected',
                    actionSubject: 'redirectToViewMode',
                    source: 'restrictedPageScreen',
                    attributes: {
                        accessType: accessType,
                        contentId: contentId
                    }
                }
            }).fire();
            experienceTracker.succeed({
                name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
            });
            if ((0, $6mKj3.expValEquals)('confluence_edit_page_restricted_redirect_ttvc_fix', 'isEnabled', true)) {
                // Abort the edit-page UFO interaction and start a new view-page transition.
                (0, $6eGYE.default)((0, $1UCmC.VIEW_PAGE_LOAD_KEY), (0, $1NBp8.VIEW_PAGE).name); // View page route is not SSR-rendered because this is a transition
                window['__SSR_RENDERED__'] = false;
            }
            replace((0, $1NBp8.VIEW_PAGE).toUrl({
                spaceKey: spaceKey,
                contentId: contentId
            }, {
                query: {
                    redirectedFromRestrict: 'true'
                }
            }));
        }
    }, [
        createAnalyticsEvent,
        contentId,
        shouldRedirectToView,
        accessType,
        spaceKey,
        replace,
        experienceTracker
    ]);
    if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null);
    else {
        /**
     * Usually, if the user doesn't have permission to view the page, the
     * query succeeds with `singleContent: null`. But occasionally we get a
     * 401 or 403, and we'd consider those to be expected errors.
     */ let hasUnhandledError = false;
        if (error) {
            if ((0, $7LI3Q.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else if ((0, $1uFM6.isUnauthorizedError)(error)) (0, $7Sm4c.markErrorAsHandled)(error);
            else hasUnhandledError = true;
        }
        return shouldRedirectToView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $fxpoI.ShowSpinnerAfterDelay), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, hasUnhandledError && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
            name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE),
            error: error
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
            error: error
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc1cd145e3df0c55$var$RestrictedPageComponent, {
            ...props,
            editDeniedButCanView: editDeniedButCanView,
            viewLink: viewLink
        }));
    }
};
const $cc1cd145e3df0c55$export$4242cfff65d64b16 = (props)=>{
    if (props.contentId && window['__SPACE_RESTRICTED_ERROR__'] === props.contentId && (0, $6mKj3.expVal)('confluence_frontend_ssr_space_not_found', 'isEnabled', false)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).PERMISSIONS_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9at9H.RestrictedSpace), {
        contentId: props.contentId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.RESTRICTED_PAGE_EXPERIENCE)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $T1bCI.Subscribe), {
        to: [
            (0, $gqqjz.FlagsStateContainer)
        ]
    }, (flags)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cc1cd145e3df0c55$var$RestrictedPageWithCanViewQuery, {
            ...props,
            flags: flags
        })));
};
module.exports["RestrictedPage"] = $cc1cd145e3df0c55$export$4242cfff65d64b16;

});

parcelRegister("e5EnV", function(module, exports) {
/**
 * @generated SignedSource<<05d10ae1ac775a7113522552abe5e792>>
 * @relayHash 6cd75834f128f4e69b90e03b31603fd0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362
const $e4798d13ae2c4a75$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "id"
        }
    ], v1 = {
        "kind": "ScalarField",
        "name": "id"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "singleContent",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "kind": "ScalarField",
                    "name": "status"
                },
                {
                    "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
                    "kind": "LinkedField",
                    "name": "links",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "webui"
                        }
                    ]
                }
            ]
        },
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v1 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "GraphQLConfluenceUserRoles",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "canBeSuperAdmin"
                                }
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "RestrictedPageWithCanViewQuery",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "6cd75834f128f4e69b90e03b31603fd0",
            "id": "12b9ea0b2a8549a655e6db18139e709c6bf2e6d45eff5ec0488c52b8b8309362",
            "metadata": {},
            "name": "RestrictedPageWithCanViewQuery",
            "operationKind": "query",
            "text": "query RestrictedPageWithCanViewQuery($id:ID!){singleContent(id:$id){id,status,links{webui}},user:confluence_atlassianUser(current:true){id,confluence{roles{canBeSuperAdmin}}}}"
        }
    };
}();
$e4798d13ae2c4a75$var$node.hash = "cac9cbea2e6f98b7e3ef1e383776a339";
var $e4798d13ae2c4a75$export$2e2bcd8739ae039 = $e4798d13ae2c4a75$var$node;
module.exports["default"] = $e4798d13ae2c4a75$export$2e2bcd8739ae039;

});

parcelRegister("7LI3Q", function(module, exports) {

var $aMcHK = parcelRequire("aMcHK");

const $02289dc82bb02982$export$55152de1f925fd05 = (error)=>(0, $aMcHK.isStatusCodeError)(error, '401');
module.exports["isUnauthorizedError"] = $02289dc82bb02982$export$55152de1f925fd05;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("3GP6F", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $QU6QS = parcelRequire("QU6QS");


var $dPJCf = parcelRequire("dPJCf");


var $lpPVE = parcelRequire("lpPVE");


var $71GjD = parcelRequire("71GjD");




const $9bc3195b956679d5$export$eddc138581adbc11 = ()=>{
    const history = (0, $dPJCf.useHistory)();
    const location = (0, $QU6QS.useLocation)();
    const queryParams = location?.search;
    const queryParamsFeatureCodes = (0, $lpPVE.getFeatureCodes)(new URLSearchParams(queryParams));
    const [featureCodes, setFeatureCodes] = (0, $42omo.useState)(queryParamsFeatureCodes);
    (0, $42omo.useEffect)(()=>{
        if (queryParams && queryParams.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
            setFeatureCodes(queryParamsFeatureCodes);
            (0, $lpPVE.hideFeatureCodesQueryParam)(history, location);
        }
    }, [
        history,
        location,
        queryParams,
        queryParamsFeatureCodes
    ]);
    return featureCodes;
};
module.exports["useFeatureCodesInURL"] = $9bc3195b956679d5$export$eddc138581adbc11;

});

parcelRegister("lpPVE", function(module, exports) {

var $9wGTI = parcelRequire("9wGTI");


var $71GjD = parcelRequire("71GjD");

const $d9de10c6417158bd$export$d347e131abf45bea = (href, featureCodes)=>{
    if (!featureCodes.length) return href;
    const [path, queryString] = href.split('?');
    const searchParams = new URLSearchParams(queryString);
    // If the query param already exists, append the new feature codes to the existing ones
    if (searchParams.has((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) {
        const existingFeatureCodes = searchParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM)) || '';
        const newFeatureCodes = [
            ...new Set([
                ...existingFeatureCodes.split(','),
                ...featureCodes
            ])
        ];
        searchParams.set((0, $71GjD.FEATURE_CODES_QUERY_PARAM), newFeatureCodes.join(','));
    } else searchParams.append((0, $71GjD.FEATURE_CODES_QUERY_PARAM), featureCodes.join(','));
    const newQueryString = searchParams.toString();
    return newQueryString ? `${path}?${newQueryString}` : path;
};
const $d9de10c6417158bd$export$3c2127388df02347 = (queryParams)=>{
    if (!(0, $9wGTI.fg)('confluence_frontend_insights_feature_attribution')) return {
        from: undefined
    };
    const featureCodes = queryParams.get((0, $71GjD.FEATURE_CODES_QUERY_PARAM))?.split(',');
    const fromCode = featureCodes?.find((code)=>Object.values((0, $71GjD.FeatureCode)).includes(code));
    return {
        from: fromCode
    };
};
const $d9de10c6417158bd$export$241f453208292937 = (history, location)=>{
    if (!location?.search?.includes((0, $71GjD.FEATURE_CODES_QUERY_PARAM))) return;
    const searchParams = new URLSearchParams(location.search);
    searchParams.delete((0, $71GjD.FEATURE_CODES_QUERY_PARAM));
    const search = searchParams.toString();
    history?.replace?.({
        ...location,
        search: search ? `?${search}` : ''
    });
};
const $d9de10c6417158bd$export$866aaa0a921ee13d = (existingFeatureCodes, featureCodeToCheck)=>{
    return existingFeatureCodes.includes(featureCodeToCheck);
};
const $d9de10c6417158bd$export$84f5742c2ddda28f = (existingFeatureCodes, featureCodeToAdd)=>{
    if ($d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToAdd)) return existingFeatureCodes;
    return [
        ...existingFeatureCodes,
        featureCodeToAdd
    ];
};
const $d9de10c6417158bd$export$f2b1b8a892016485 = (existingFeatureCodes, featureCodeToRemove)=>{
    if (!$d9de10c6417158bd$export$866aaa0a921ee13d(existingFeatureCodes, featureCodeToRemove)) return existingFeatureCodes;
    return existingFeatureCodes.filter((code)=>code !== featureCodeToRemove);
};
module.exports["generatePathWithFeatureCodesQueryParam"] = $d9de10c6417158bd$export$d347e131abf45bea;
module.exports["getFeatureCodes"] = $d9de10c6417158bd$export$3c2127388df02347;
module.exports["hideFeatureCodesQueryParam"] = $d9de10c6417158bd$export$241f453208292937;

});

parcelRegister("71GjD", function(module, exports) {
/**
 * Feature attribution enum for tracking feature usage/attribution
 *
 * @note All feature codes are intended to be 8 characters or less in length
 *
 * @see https://hello.atlassian.net/wiki/x/lQxt9Q
 */ var $9d2fac30cbee1d6f$export$661babcb078ff919 = /*#__PURE__*/ function(FeatureCode) {
    /** Confluence Home Feeds (Following and Popular) **/ FeatureCode["HOME_FEED"] = "HOMEFEED";
    /** Confluence End of Page Recommendations (Related Pages) **/ FeatureCode["EOP_REC"] = "EOPREC";
    /** Confluence End of Page Recommendations (Related Pages) Hover Card **/ FeatureCode["EOP_REC_CARD"] = "EOPCARD";
    /** Confluence Page Tree **/ FeatureCode["PAGE_TREE"] = "PAGETREE";
    /** Confluence Page Tree Card **/ FeatureCode["PAGE_TREE_CARD"] = "TREECARD";
    /** Following Feed email **/ FeatureCode["FOLLOWING_FEED_EMAIL"] = "FLLWEML";
    /** Popular Feed email **/ FeatureCode["POPULAR_FEED_EMAIL"] = "PPLREML";
    FeatureCode["ADMIN_KEY_EMAIL"] = "ADMINEML";
    FeatureCode["ATTACHMENT_EMAILS"] = "ATTCHEML";
    FeatureCode["BATCH_EMAIL"] = "BATCHEML";
    FeatureCode["BLOG_CREATED_EMAIL"] = "BLOGEML";
    FeatureCode["BULK_ARCHIVE_EMAIL"] = "BLKAREML";
    FeatureCode["BULK_OWNER_CHANGE_EMAIL"] = "BLKOWEML";
    FeatureCode["CONFLUENCE_WRAPPED_EMAIL"] = "WRAPEML";
    FeatureCode["CONTACT_ADMINISTRATORS_EMAIL"] = "CTADMEML";
    FeatureCode["CONTENT_OWNER_CHANGE_EMAIL"] = "OWNREML";
    FeatureCode["CONTENT_REDACTION_EMAIL"] = "RDCTDEML";
    FeatureCode["EXCO_ADDED_TO_SPACE_EMAIL"] = "EXCASEML";
    FeatureCode["EXCO_REQUEST_ACCESS_EMAIL"] = "EXCRAEML";
    FeatureCode["EXCO_SPACE_READY_EMAIL"] = "EXCSREML";
    FeatureCode["IMPORTER_NOTIFICATIONS"] = "IMPRTNTF";
    FeatureCode["LIVE_PAGE_PUBLISHED_EMAIL"] = "LPPEML";
    FeatureCode["MENTIONS_EMAIL"] = "MNTNEML";
    FeatureCode["PAGE_CREATED_EMAIL"] = "PAGEEML";
    FeatureCode["REMINDER_EMAIL"] = "RMNDREML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_EMAILS"] = "REQACEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_SLACK"] = "REQACSLK";
    FeatureCode["TASKS_EMAIL"] = "TASKEML";
    FeatureCode["TEAM_CALENDAR_EMAIL"] = "CLNDREML";
    FeatureCode["WHITEBOARD_CREATED_EMAIL"] = "WTBRDEML";
    FeatureCode["CONTENT_REDACTION_IN_APP"] = "RDCTDAPP";
    FeatureCode["DAILY_DIGEST_EMAIL"] = "DIGSTEML";
    FeatureCode["MENTIONS_REMINDER_EMAIL"] = "MNTNREML";
    FeatureCode["PUBLIC_LINK_EMAIL"] = "PBLNKEML";
    FeatureCode["REQUEST_AND_GRANT_ACCESS_IN_APP"] = "REQACAPP";
    FeatureCode["SHARE_AND_RESTRICT_DIALOG"] = "SRDIALOG";
    FeatureCode["ROVO_CHAT_LINK"] = "ROVOCHAT";
    FeatureCode["ROVO_EXTENSION_LINK"] = "ROVOEXT";
    return FeatureCode;
}({});
const $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd = 'atl_f';
const $9d2fac30cbee1d6f$export$384cf7f2010cb469 = 'confluence_frontend_insights_feature_attribution';
module.exports["FeatureCode"] = $9d2fac30cbee1d6f$export$661babcb078ff919;
module.exports["FEATURE_CODES_QUERY_PARAM"] = $9d2fac30cbee1d6f$export$18fd2ee3b879d0cd;

});

parcelRegister("dmDX7", function(module, exports) {

var $7NYI2 = parcelRequire("7NYI2");


var $42omo = parcelRequire("42omo");


var $jMyy4 = parcelRequire("jMyy4");


var $bQm3c = parcelRequire("bQm3c");


var $6mKj3 = parcelRequire("6mKj3");

const $4aa29e57813b75ee$var$UsePendingRequestExistsQuery = (0, $7NYI2.default);
const $4aa29e57813b75ee$export$5354a7f39c2c364a = ({ contentId: contentId })=>{
    const { userId: userId, cloudId: cloudId } = (0, $bQm3c.useSessionData)();
    const shouldSkip = !userId || !cloudId || !contentId || !(0, $6mKj3.expValEquals)('confluence_frontend_existing_access_request_checks', 'cohort', 'experiment');
    const [isLoadingForFirstTime, setIsLoadingForFirstTime] = (0, $42omo.useState)(!shouldSkip);
    const { data: data, error: error, loading: loading } = (0, $jMyy4.useQueryInterop)($4aa29e57813b75ee$var$UsePendingRequestExistsQuery, {
        variables: {
            cloudId: cloudId,
            accessRequestedAaid: userId ?? '',
            contentId: contentId ?? ''
        },
        skip: shouldSkip,
        fetchPolicy: 'network-only',
        onCompleted: ()=>{
            setIsLoadingForFirstTime(false);
        },
        __callerPackage__: "@confluence/access-requests"
    });
    const pendingRequestExists = Boolean(data?.confluence_pendingRequestExists?.isPendingAccessRequestExists);
    return {
        pendingRequestExists: pendingRequestExists,
        loading: loading,
        error: error,
        isLoadingForFirstTime: isLoadingForFirstTime
    };
};
module.exports["usePendingRequestExists"] = $4aa29e57813b75ee$export$5354a7f39c2c364a;

});

parcelRegister("7NYI2", function(module, exports) {
/**
 * @generated SignedSource<<c2dfd6c4d3d5c9094f289e2a6367c967>>
 * @relayHash f8787096f4d42896880d52d9cbd4670c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9
const $3cde78eca68e7b16$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "accessRequestedAaid"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "accessRequestedAaid",
                    "variableName": "accessRequestedAaid"
                },
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "ConfluencePendingAccessRequest",
            "kind": "LinkedField",
            "name": "confluence_pendingRequestExists",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "isPendingAccessRequestExists"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "usePendingRequestExistsQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f8787096f4d42896880d52d9cbd4670c",
            "id": "ca265d253ef91a90727e0b2a379d714b1851230382cb448d534c1124fd0266b9",
            "metadata": {},
            "name": "usePendingRequestExistsQuery",
            "operationKind": "query",
            "text": "query usePendingRequestExistsQuery($accessRequestedAaid:String!,$cloudId:ID!,$contentId:ID!){confluence_pendingRequestExists(accessRequestedAaid:$accessRequestedAaid,cloudId:$cloudId,contentId:$contentId){isPendingAccessRequestExists}}"
        }
    };
}();
$3cde78eca68e7b16$var$node.hash = "4d877c3ca505e954e3d6f173f1138ce0";
var $3cde78eca68e7b16$export$2e2bcd8739ae039 = $3cde78eca68e7b16$var$node;
module.exports["default"] = $3cde78eca68e7b16$export$2e2bcd8739ae039;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});


//# sourceMappingURL=RestrictedPage.81a1b3b8.js.map
